// text contents for Login.tsx
export const login = {
	initialLogin: {
		title: `Welcome to the Allison Connected Capabilities Service for Fleet Management`,
		body1: `Allison Transmission has collaborated with several organizations, including your chosen Telematics Service Solutions channel, to provide transmission related information for end user fleets.`,
		body2: `In order for you to receive this information through your chosen channel, it is necessary that you sign a data sharing agreement.`,
		body3: `Please create a customer profile in order to get started!`,
	},
	pin: {
		title: `In order to continue please check your email and enter the six (6) digit PIN that was sent to you.`,
		subtitle: `Step 2 of 2`,
		resend: `If you did not receive an email with the PIN, please click the "Resend PIN" button above. If you do not receive this again, please contact us using the "Contact" link in the upper-right corner of the page, and we will provide you with assistance.`,
	},
};
